var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.81625C9.97324 2.45803 8.39046 1.09982 4.46778 1.00015C4.21012 0.993609 4 1.21112 4 1.47899C4 3.4661 4 10.989 4 13.2139C4 13.4818 4.21014 13.6922 4.46773 13.7009C8.39045 13.8342 9.97324 15.6417 11 17M11 3.81625C12.0268 2.45803 13.6095 1.09982 17.5322 1.00015C17.7899 0.993609 18 1.20623 18 1.4741C18 3.69536 18 10.9919 18 13.2132C18 13.4811 17.7899 13.6922 17.5323 13.7009C13.6096 13.8342 12.0268 15.6417 11 17M11 3.81625V17",
    stroke: "#6C6C6C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3735 3H19.525C19.7873 3 20 3.20894 20 3.46667V15.6364C20 16.014 19.5471 16.2649 19.1958 16.1116C18.4405 15.7818 17.1799 15.379 15.5294 15.379C12.7353 15.379 10.5 17 10.5 17C10.5 17 8.26471 15.379 5.47059 15.379C3.82003 15.379 2.55948 15.7818 1.80415 16.1116C1.45285 16.2649 1 16.014 1 15.6364V3.46667C1 3.20894 1.21267 3 1.475 3H3.62647",
    stroke: "#6C6C6C",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonIcon);
export default __webpack_public_path__ + "static/media/lesson_icon.634200de817554ca6172320c7161fa1e.svg";
export { ForwardRef as ReactComponent };